import { render, staticRenderFns } from "./subsystem.vue?vue&type=template&id=0c8a024f&scoped=true&"
import script from "./subsystem.vue?vue&type=script&lang=js&"
export * from "./subsystem.vue?vue&type=script&lang=js&"
import style0 from "./subsystem.vue?vue&type=style&index=0&id=0c8a024f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a024f",
  null
  
)

export default component.exports